// Central date formatting helpers — German short format "dd.mm.jj"
// per project spec (all user-facing dates use 2-digit year).

function _pad(n) { return String(n).padStart(2, "0"); }

function _toDate(iso) {
  if (!iso) return null;
  const s = String(iso);
  // Pure "YYYY-MM-DD" (no time component) — parse manually to avoid UTC-midnight
  // rendering as the previous day in negative-UTC-offset timezones.
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** Format any ISO date/string as "dd.mm.jj" (2-digit year). Returns "—" on failure. */
export function formatDeShort(iso, fallback = "—") {
  const d = _toDate(iso);
  if (!d) return fallback;
  return `${_pad(d.getDate())}.${_pad(d.getMonth() + 1)}.${_pad(d.getFullYear() % 100)}`;
}

/** Format an ISO date-time as "dd.mm.jj HH:MM". Returns "—" on failure. */
export function formatDeShortDateTime(iso, fallback = "—") {
  const d = _toDate(iso);
  if (!d) return fallback;
  return `${_pad(d.getDate())}.${_pad(d.getMonth() + 1)}.${_pad(d.getFullYear() % 100)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}

/** Format an ISO date as "dd.mm" (day+month only). */
export function formatDeDayMonth(iso, fallback = "—") {
  const d = _toDate(iso);
  if (!d) return fallback;
  return `${_pad(d.getDate())}.${_pad(d.getMonth() + 1)}.`;
}
